export class BarDataset {
  label: string;
  backgroundColor = new Array<string>();
  data = new Array<number>();
}
